// extracted by mini-css-extract-plugin
export default {"container":"jp-z","ratingLayout":"kp-z","ratingLabel":"lp-z","nonInteractiveRatingLabel":"mp-z"};